import React, { useState } from 'react';
import { keyBy } from 'lodash';
import { createBoard } from '../../../firebase/api/boards-private';
import { useInvitations } from '../../../firebase/api/invitations';
import { IBoard } from '../../../firebase/api/typings';
import ListItem from '../ListItem';
import styled from 'styled-components';
import { onlyUnique } from '../../../utils/array';

const Title = styled.div`
  color: #1d1d1d90;
  background: #a3a3a353;
  margin: 15px 0 5px;
  padding: 5px;
  font-weight: bold;
`;

const Empty = styled.div`
  color: #999;
  padding: 0 5px;
`;

interface IProps {
  boards: IBoard[];
  currentBoard: string;
  setCurrentBoard: (id: string) => void;
  setCurrentUser: (id: string) => void;
}

const BoardList: React.FC<IProps> = (props) => {
  const [boardName, setBoardName] = useState<string>('');
  const { invitations } = useInvitations();

  const boardsWithUsers = props.boards.filter((board) => !!board.invited);

  const usersOnly: any[] = boardsWithUsers.map((board) => board.invited);

  const boardUsers = usersOnly
    .map((board) => Object.keys(board).map((key) => ({ id: key, name: board[key] })))
    .reduce((previousValue, currentValue, index, self) => {
      return previousValue.concat(self[index]);
    }, []);

  const boardUsersIds = boardUsers.map((el) => el.id).filter(onlyUnique);

  const userNamesByIds = keyBy(boardUsers, 'id');

  const myBoardsUsers = boardUsersIds.map((id) => ({
    id,
    name: userNamesByIds[id].name,
  }));

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    createBoard(boardName);
    setBoardName('');
  };

  return (
    <ul className="list">
      <form onSubmit={submit}>
        <input
          type="text"
          placeholder="Добавить доску"
          value={boardName}
          onChange={(e) => setBoardName(e.target.value)}
        />
      </form>
      <Title>Приглашения к доскам:</Title>
      {!!invitations.length ? (
        invitations.map((b) => (
          <ListItem
            key={b.id}
            onClick={() => props.setCurrentBoard(b.id)}
            style={{ color: props.currentBoard === b.id ? '#000' : '#999' }}
          >
            {b.title}
          </ListItem>
        ))
      ) : (
        <Empty>Приглашения отсутствуют</Empty>
      )}
      <Title>Мои доски:</Title>

      {!!props.boards.length ? (
        props.boards
          .sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime())
          .reverse()
          .map((b) => (
            <ListItem
              key={b.id}
              onClick={() => props.setCurrentBoard(b.id)}
              style={{ color: props.currentBoard === b.id ? '#000' : '#999' }}
            >
              {b.name}
            </ListItem>
          ))
      ) : (
        <Empty>Доски отсутствуют</Empty>
      )}
      <Title>Архив:</Title>
      <ListItem
        onClick={() => props.setCurrentBoard('ready')}
        style={{ color: props.currentBoard === 'ready' ? '#000' : '#999' }}
      >
        Готово
      </ListItem>
      {!!myBoardsUsers.length && (
        <>
          <Title>Статистика пользователей:</Title>
          {myBoardsUsers.map((user) => (
            <ListItem key={user.id} onClick={() => props.setCurrentUser(user.id)}>
              {user.name}
            </ListItem>
          ))}
        </>
      )}
    </ul>
  );
};

export default BoardList;
